import React, { useEffect, useState } from "react"
import styled from "styled-components"
import { useQuery } from "@apollo/client"
import { useSelector } from "react-redux"
import { useAppDispatch } from "lib/store"
import { toggleEditSidebar } from "lib/store/services/editSidebar/slice"
import { editSidebarOpen } from "lib/store/services/editSidebar/selectors"

import ALL_PAYMENT_PROVIDERS from "graphql/queries/config/AllPaymentProviders"

import PageHeader from "components/Ui/Page/PageHeader"
import PrimaryButton from "components/Ui/Buttons/PrimaryButton"
import CreateSveaConfig from "./CreateSveaConfig"
import { SveaConfigTable } from "components/Config/Svea/SveaConfigTable"
import EditSveaConfig from "./EditSveaConfig"

import { ReactComponent as PlusIcon } from "images/icons/plus.svg"
import { ReactComponent as SveaLogo } from "images/providers/svea-logo.svg"
import { WithAuth } from "../../../../components/Auth"
import { PermissionGroups } from "../../../../routes/constants"

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`

const PageSveaLogo = styled(SveaLogo)`
  height: 5rem;
`

export const SveaConfiguration = () => {
  const [sveaConfigId, setSveaConfigId] = useState<string>("")
  const isSidebarOpen = useSelector(editSidebarOpen)
  const { loading, data, refetch, error } = useQuery(ALL_PAYMENT_PROVIDERS)
  const paymentProviders = data?.getPaymentProviders
  const dispatch = useAppDispatch()

  useEffect(() => {
    if (!isSidebarOpen) {
      setSveaConfigId("")
    }
  }, [isSidebarOpen])

  return (
    <Container>
      <PageHeader
        title={<PageSveaLogo />}
        description={<>Handle your Svea Checkout configurations</>}
        goBackLinkText="Back to providers"
        goBackLinkUrl={"/settings/providers"}
      >
        <WithAuth requiredGroups={PermissionGroups.providers.write}>
          <PrimaryButton type="button" handleClick={() => dispatch(toggleEditSidebar())}>
            <PlusIcon /> Add new configuration
          </PrimaryButton>
        </WithAuth>
      </PageHeader>
      {!sveaConfigId && <CreateSveaConfig refetch={refetch} />}
      {sveaConfigId && (
        <EditSveaConfig sveaConfigId={sveaConfigId} setSveaConfigId={setSveaConfigId} refetch={refetch} />
      )}
      <SveaConfigTable
        providers={paymentProviders}
        error={error}
        setSveaConfigId={setSveaConfigId}
        loading={loading}
      />
    </Container>
  )
}
